import type { Question } from '@/features/jobs/questions/questions'
import { numberToLocaleString } from '@/utils/number-util'

/**
 * Gets the question's answer as a textual representation/
 * @param question
 */
export function getQuestionAnswerAsText(question: Question): string {
  if (question.answer === null) {
    return ''
  }

  switch (question.type) {
    case 'Bool': {
      return question.answer.value ? 'Yes' : 'No'
    }
    case 'Select': {
      const getOptionText = (id: string) =>
        question.options.find((o) => o.id === id)?.text ?? id

      if (question.answer.type === 'MultiSelectAnswer') {
        return question.answer.value.map(getOptionText).join(', ')
      }

      return getOptionText(question.answer.value)
    }
    case 'Text': {
      return question.answer.value
    }
    case 'Numeric': {
      const places =
        question.format.type === 'Decimal' ? question.format.places : 0
      return numberToLocaleString(question.answer.value, places)
    }
    case 'DateTime': {
      const formatter = new Intl.DateTimeFormat('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        ...(question.collectTime && {
          hour: 'numeric',
          minute: '2-digit',
        }),
      })

      return formatter.format(question.answer.value)
    }
    case 'Breaker': {
      return ''
    }
    case 'Unknown': {
      return ''
    }
    default:
      return ''
  }
}
